import type { GridCard } from '@Components/BigBrowse/Model/Classes/GridCard';
import type { PlaneTypes } from '@Components/BigBrowse/Model/ModelTypes';
import { observer } from 'mobx-react-lite';

import { MoreCtaButton } from '../../primitives/MoreCtaButton';

import externalLinkService from '~gateways/external-link';

type Props = {
  gridCard: GridCard<PlaneTypes.Layout_HeroAndText_TextPart>;
  marginTop?: number;
};

export const HeroAndTextMoreCta = observer(function ThreeUpMoreCta({
  gridCard,
}: Props) {
  const { data } = gridCard;
  const { props: textProps, size, marginTop } = data!.styles!.textPart!.cta!;

  const onClick = () => {
    externalLinkService.openUrl(data!.dtoData.linkButtonUrl);
  };

  return (
    <MoreCtaButton
      textProps={textProps}
      size={size}
      marginTop={marginTop}
      onClick={onClick}
      radius={45}
    />
  );
});
